// Storage adapter backed by the standalone Jigyasa FastAPI backend.
// Implements the same interface as createMemoryStorage / supabaseStorage
// (see storage.js) — the engine stays storage-agnostic.

import { api } from "../standalone/api";

export const createApiStorage = () => ({
  loadEnquiries: async () => (await api.get("/enquiries")).data,
  loadOrgSettings: async () => {
    const { data } = await api.get("/org");
    return {
      sources: data.sources || [],
      enquiry_types: data.enquiry_types || [],
      lost_reasons: data.lost_reasons || [],
      stages: data.stages || [],
      lines: data.lines || [],
    };
  },
  createEnquiry: async (rec) => {
    await api.post("/enquiries", rec);
  },
  updateEnquiry: async (id, patch) => {
    await api.patch(`/enquiries/${id}`, patch);
  },
  deleteEnquiry: async (id) => {
    await api.delete(`/enquiries/${id}`);
  },
  addRemark: async (enquiryId, remark) => {
    await api.post(`/enquiries/${enquiryId}/remarks`, remark);
  },
  updateOrgSettings: async (patch) => {
    if (patch.sources) await api.put("/org/sources", { sources: patch.sources });
    if (patch.enquiry_types) await api.put("/org/types", { enquiry_types: patch.enquiry_types });
    if (patch.lost_reasons) await api.put("/org/lost-reasons", { lost_reasons: patch.lost_reasons });
    if (patch.stages) await api.put("/org/stages", { stages: patch.stages });
    if (patch.lines) await api.put("/org/lines", { lines: patch.lines });
  },
});
